import api from '@/services/api'
const url = action => `/charts/${action}`

export async function postProductionAnalysisData(requestBody){
    const { data: res } = await api.post(url('queryProductAnalysisData'),requestBody)
    return res
}

export async function postSalesAnalysisData(requestBody){
    const { data: res } = await api.post(url('querySalesAnalysisData'),requestBody)
    return res
}

export async function getSexAndCompanySummaryChart(){
    const { data: res } = await api.get('/sexandcompanysummarychart')
    return res
}

export async function postSalesmanAnalysisData(requestBody){
    const { data: res } = await api.post(url('querySalesmanAnalysisData'),requestBody)
    return res
}